"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var helpers_1 = require("../../utils/component/helpers");
function getLabel(native) {
    var clickLabel;
    if (native.cta) {
        // v3
        clickLabel = native.cta;
    }
    else if (native.custom && native.custom.destination_label) {
        // v2
        clickLabel = native.custom.destination_label;
    }
    else {
        clickLabel = helpers_1.formatUrl(native.clickUrl);
    }
    return helpers_1.escape(clickLabel);
}
var CtaButton = function (_a) {
    var native = _a.native, className = _a.className, style = _a.style;
    return (React.createElement("button", { className: className, style: style }, getLabel(native)));
};
exports.default = CtaButton;
